module.exports = __webpack_public_path__ + "static/media/rich11.12e5ad5f.JPG";